import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, errors,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.NumerInput
          value={row.year}
          onChange={(e, v) => actions.onChange(e, row.id, { year: v })}
          readOnly={fields.year.read_only || readOnly}
          errors={errors && errors.year}
        />
      </TableCell>

      <TableCell>
        <TableControls.NumerInput
          value={row.area_total}
          onChange={(e, v) => actions.onChange(e, row.id, { area_total: v })}
          readOnly={fields.area_total.read_only || readOnly}
          errors={errors && errors.area_total}
          precision={2}
        />
      </TableCell>

      <TableCell>
        <TableControls.NumerInput
          value={row.area_live}
          onChange={(e, v) => actions.onChange(e, row.id, { area_live: v })}
          readOnly={fields.area_live.read_only || readOnly}
          errors={errors && errors.area_live}
          precision={2}
        />
      </TableCell>

      <TableCell>
        <TableControls.NumerInput
          value={row.area_hot}
          onChange={(e, v) => actions.onChange(e, row.id, { area_hot: v })}
          readOnly={fields.area_hot.read_only || readOnly}
          errors={errors && errors.area_hot}
          precision={2}
        />
      </TableCell>

      <TableCell>
        <TableControls.NumerInput
          value={row.area_summer}
          onChange={(e, v) => actions.onChange(e, row.id, { area_summer: v })}
          readOnly={fields.area_summer.read_only || readOnly}
          errors={errors && errors.area_summer}
          precision={2}
        />
      </TableCell>

      <TableCell>
        <TableControls.NumerInput
          value={row.amount_room}
          onChange={(e, v) => actions.onChange(e, row.id, { amount_room: v })}
          readOnly={fields.amount_room.read_only || readOnly}
          errors={errors && errors.amount_room}
          precision={2}
        />
      </TableCell>

      <TableCell>
        <TableControls.NumerInput
          value={row.account_electro}
          onChange={(e, v) => actions.onChange(e, row.id, { account_electro: v })}
          readOnly={fields.account_electro.read_only || readOnly}
          errors={errors && errors.account_electro}
        />
      </TableCell>

      <TableCell>
        <TableControls.NumerInput
          value={row.account_gas}
          onChange={(e, v) => actions.onChange(e, row.id, { account_gas: v })}
          readOnly={fields.account_gas.read_only || readOnly}
          errors={errors && errors.account_gas}
        />
      </TableCell>

    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number,
    year: PropTypes.string,
    area_total: PropTypes.number,
    area_live: PropTypes.number,
    area_hot: PropTypes.number,
    area_summer: PropTypes.number,
    amount_room: PropTypes.number,
    account_electro: PropTypes.number,
    account_gas: PropTypes.number,
  }).isRequired,
  fields: PropTypes.shape({
    year: PropTypes.shape({ read_only: PropTypes.bool }),
    area_live: PropTypes.shape({ read_only: PropTypes.bool }),
    area_total: PropTypes.shape({ read_only: PropTypes.bool }),
    area_hot: PropTypes.shape({ read_only: PropTypes.bool }),
    area_summer: PropTypes.shape({ read_only: PropTypes.bool }),
    amount_room: PropTypes.shape({ read_only: PropTypes.bool }),
    account_electro: PropTypes.shape({ read_only: PropTypes.bool }),
    account_gas: PropTypes.shape({ read_only: PropTypes.bool }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  errors: PropTypes.shape({
    year: PropTypes.arrayOf(PropTypes.string),
    area_total: PropTypes.arrayOf(PropTypes.string),
    area_live: PropTypes.arrayOf(PropTypes.string),
    area_hot: PropTypes.arrayOf(PropTypes.string),
    area_summer: PropTypes.arrayOf(PropTypes.string),
    amount_room: PropTypes.arrayOf(PropTypes.string),
    account_electro: PropTypes.arrayOf(PropTypes.string),
    account_gas: PropTypes.arrayOf(PropTypes.string),
  }),
};

Row.defaultProps = {
  readOnly: false,
  active: false,
  errors: null,
};

export default memo(Row);
